import React, { useState } from 'react';

import UseModal from 'hooks/use-modal';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { useRouter } from 'next/router';
import Modal from '@core/components/Modal/Modal';
import ActionButton from '@core/components/actionbutton/ActionButton';
import CartPayment from 'components/pages/cart/CartPayment';
import SubscriptionPaymentWrapper from 'components/pages/plans/payment/SubscriptionPaymentWrapper';
import SubscriptionPaymentStepper from 'components/pages/plans/payment/subscriptionpaymentstepper/SubscriptionPaymentStepper';

import { addZeroToOneDecimal } from 'utils/numbersShowingUtils';

import classes from './SelectYourPlanSection.module.scss';


const SelectYourPlanSection = ({ data, isLoggedIn, toast }) => {
    const router = useRouter();
    const [period, setPeriod] = useState('');
    const { show, showModal, destroyModal } = UseModal();
    const refetchCart = () => {

    };
    const monthlyClickHandler = () => {
        if (isLoggedIn) {
            setPeriod('Monthly');
            showModal();
        }
        else {
            router.push('/login?next=' + router.asPath);
        }

    };
    const annualClickHandler = () => {
        if (isLoggedIn) {
            setPeriod('Annual');
            showModal();
        }
        else {
            router.push('/login?next=' + router.asPath);
        }
    };

    return (
        <>
            <div className={classes['wrapper']}>
                <div className="container py-5">
                    <div className="row d-flex flex-column align-items-center">
                        <h3>
                            Select your plan
                        </h3>
                        <p>
                            Choose the plan that fits your career goals best. Go for the flexible monthly option
                            or save big with the annual plan. Invest in your future with Pharmuni Premium and start your journey today!
                        </p>
                    </div>
                    <div className="row d-flex justify-content-center mt-5">
                        <div className="col-12 col-md-6 col-xl-4 d-flex justify-content-end">
                            <div className={`${classes['price-card']} ${classes['monthly']}`}>
                                <div className={classes['price-wrapper']}>
                                    <div className={classes['title']}>Monthly</div>
                                    {data.monthly.discounted_price == null ? (
                                        <div className={classes['price']}>{data.monthly.currency.symbol}{addZeroToOneDecimal(data.monthly.price)}<span className={classes['duration']}>/mo</span> </div>
                                    ) : (
                                        <>
                                            <div className={classes['discounted-price']}><span>{data.monthly.currency.symbol}{addZeroToOneDecimal(data.monthly.price)}</span></div>
                                            <div className={classes['price']}>{data.monthly.currency.symbol}{addZeroToOneDecimal(data.monthly.discounted_price)}<span className={classes['duration']}>/mo</span> </div>
                                        </>
                                    )}
                                </div>
                                <ActionButton kind='secondary' onClick={monthlyClickHandler}>
                                    Select Plan
                                </ActionButton>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4 mt-4 mt-md-0">
                            <div className={`${classes['price-card']} ${classes['annual']}`}>
                                <div className={classes['price-wrapper']}>
                                    <div className={classes['title']}>Annual</div>
                                    {data.yearly.discounted_price == null ? (
                                        <div className={classes['price']}>{data.yearly.currency.symbol}{addZeroToOneDecimal(data.yearly.price)}<span className={classes['duration']}>/mo</span> </div>
                                    ) : (
                                        <>
                                            <div className={classes['discounted-price']}><span>{data.yearly.currency.symbol}{addZeroToOneDecimal(data.yearly.price)}</span></div>
                                            <div className={classes['price']}>{data.yearly.currency.symbol}{addZeroToOneDecimal(data.yearly.discounted_price)}<span className={classes['duration']}>/mo</span> <span className={classes['save']}>Save {data.yearly.currency.symbol}{addZeroToOneDecimal(data.yearly.saving)}</span></div>
                                        </>
                                    )}
                                </div>
                                <ActionButton kind='secondary' onClick={annualClickHandler}>
                                    Select Plan
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                header={true}>
                {/* <div className={classes['payment-modal']}>
                    <SubscriptionPaymentWrapper
                        closeHandler={destroyModal}
                        toast={toast}
                        period={period}
                        setPeriod={setPeriod}
                    />                    
                </div> */}
                <SubscriptionPaymentStepper
                    closeHandler={destroyModal}
                    toast={toast}
                    period={period}
                    setPeriod={setPeriod}
                />
            </Modal>
        </>
    );
};

export default SelectYourPlanSection;